import jwt from 'jwt-decode'
import { getUserInfo } from '@/utils/auths.js'
import routes from "@/router/config"
import { Empty } from 'antd'
import intl from 'react-intl-universal'
export const getConfigList = () => {
    const arr = []
    const arrPath = []
    const getArrs = (list) => {
        list.forEach(item => {
            let value = {
                authority: item.authority && item.authority.length > 0 ? item.authority : []
            }
            if (item.path) {
                arr.forEach(item => {
                    arrPath.push(item.path)
                })
                if (arrPath.indexOf(item.path) < 0) {
                    value.path = item.path
                    arr.push(value)
                }
            }
            if (item.routes) {
                getArrs(item.routes)
            }

        })
    }
    getArrs(routes)
    return arr
}
export const handelGoOnePath = (layoutArr, isShowRoutesArr, arrCharge, history) => {
    const pathLocation = history.location.pathname
    const goOnePath = handelAuthArr(layoutArr)
    if (pathLocation === '/layout') {
        const arrPathGoOne = isShowRoutesArr.findIndex(item => item.path === goOnePath)
        if (arrPathGoOne >= 0) {
            isShowRoutesArr.forEach(item => {
                if (goOnePath === item.path) {
                    history.replace(handelAuthArr(item.routes))
                }
            })
        } else {
            history.replace(goOnePath)
        }

    }
    const handelHasAuthArr = (list) => {
        list.forEach(item => {
            if (pathLocation === item.path) {
                history.replace(handelAuthArr(item.routes))
            }
        })
    }
    handelHasAuthArr(arrCharge)
}
export const handelLayoutArr = (layoutArr, history) => {
    const arrCharge = []
    const isShowRoutesArr = []
    const getChargeArr = (list) => {
        list.forEach(item => {
            if (item.routes?.length > 0) {
                if (item.isChargeProfessional) {
                    arrCharge.push(item)
                } else {
                    getChargeArr(item.routes)
                }
            }
        })
    }
    layoutArr.forEach(item => {
        if (item.isShowRoutes) {
            isShowRoutesArr.push(item)
        }
    })
    getChargeArr(layoutArr)
    handelGoOnePath(layoutArr, isShowRoutesArr, arrCharge, history)

}
export const handelAuthPage = (history) => {
    const layoutArr = []
    routes.forEach(item => {
        if (item.path === "/layout") {
            item.routes.forEach(itemChild => {
                if (itemChild.isOne) {
                    layoutArr.push(itemChild)
                }
            })
        }
    })
    handelLayoutArr(layoutArr, history)
}



export const handelAuthArr = (list) => {
    const hasAuthArr = []
    list.forEach(item => {
        if (item.authority?.length > 0) {
            const authChargeArr = []
            item.authority.forEach(itemAuth => {
                if (itemAuth) {
                    if (getAllAuthList(itemAuth)) {
                        authChargeArr.push('trues')
                    }
                }
            })
            if (authChargeArr.length > 0) {
                hasAuthArr.push(item)
            }
        }
    })
    return hasAuthArr[0].path
}


export const getAllAuthList = (value) => {
    const authList = getUserInfo() ? getUserInfo().authorityList : []
    const line = value && authList && authList.length > 0 ? authList.indexOf(value) : -1
    return line >= 0
}
export const getValue = (value) => {
    if (value || value === 0 || value == '0') {
        return value
    } else {
        return <div className='cursor-default-com'>-</div>
    }
}

export const throttle = (fn, ms) => {
    // 创建一个标记用来存放定时器的id
    let timerId
    return function () {
        // 没有定时器等待执行，则表示可以创建新的定时器来执行函数
        if (!timerId) {
            timerId = setTimeout(() => {
                // 定时器id清空，表示可以执行下一次调用了
                timerId = null
                fn.apply(this, arguments)
            }, ms)
        }
    }
}
export const isBeyond = (e) => {
    // 浏览器兼容，最好写一下
    const ev = e
    const textRange = (el) => {
        const textContent = el
        const targetW = textContent.getBoundingClientRect().width
        const range = document.createRange()
        range.setStart(textContent, 0)
        range.setEnd(textContent, textContent.childNodes.length)
        const rangeWidth = range.getBoundingClientRect().width
        return rangeWidth > targetW
    }
    return !textRange(ev.target)
}

export const token_decode = (data) => {
    return jwt(data)
}
export const get = (data, value) => {
    return intl.get(data, value)
}
export const getRenderEmpty = () => {
    return <Empty
        imageStyle={{
            height: 50,
        }}
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
            <span>
                {get('notData')}
            </span>
        }
    />
}